import { Tube } from '@react-three/drei';
import React from 'react';
import { CatmullRomCurve3, Vector3 } from 'three';

import { SnapLineProps } from '../../@types/Components';
import { SNAP_LINE_THICKNESS, TUBE_RADIAL_SEGMENTS, TUBE_SIZE } from '../../utils/constants';

const SnapLine = ({
    point1,
    point2,
    color,
    thickness = SNAP_LINE_THICKNESS
}: SnapLineProps): React.JSX.Element => {
    const [x1, y1] = point1;
    const [x2, y2] = point2;

    // Create a curve that just consists of the two points
    const curve = new CatmullRomCurve3([
        new Vector3(x1, y1, 0),
        new Vector3(x2, y2, 0)
    ]);

    return (
        <Tube
            name={"tube-snapLine"}
            args={[curve, TUBE_SIZE, thickness / 2, TUBE_RADIAL_SEGMENTS, false]}
        >
            <meshBasicMaterial
                attach="material"
                color={color}
                name={"tube-snapLine-meshBasicMaterial"}
            />
        </Tube>
    );
};

export default SnapLine;
